const routes = [
    {
        path: "/car/brands",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'carbrand_index'
        }
    }
];

export default routes;
